import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import Router from 'react-router/lib/Router';
import configureStore from './Stores';
import { routes } from './Routes';
import { syncHistoryWithStore } from 'react-router-redux'
import browserHistory from './History';
// import jwtDecode from 'jwt-decode';
import _ from 'lodash';

const store = configureStore();
const history = syncHistoryWithStore(browserHistory, store);

history.listen(location => {
    try {
       
        
    } catch(error) {
        console.log(error);
    }
})

render(
    <Provider store={ store }>
        <Router 
            history={ history } 
            routes={ routes }/>
    </Provider>,
    document.getElementById('root')
);



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/